/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import cleanUpResponse from '@/util/cleanUpResponse';
import { parseServerDateTime, formatServerDate } from '@/util/MomentUtils';

export default async function SearchOrderPackages(parameters) {
  const response = await $.soap({
    body: {
      SearchOrderPackages: {
        $xmlns: 'http://dla.mil/ems/bpm/order_package',
        RETURN_VALUE: '',
        ID: parameters.orderPackageID,
        CommandName: parameters.commandName,
        StatusID: parameters.statusID,
        TypeID: parameters.typeID,
        DateCreatedStart: parameters.createdOnStart,
        DateCreatedEnd: parameters.createdOnEnd,
        POPStartDateStart: parameters?.popStartDateStart,
        POPStartDateEnd: parameters?.popStartDateEnd
      }
    },
    blueprintArrays: ['SearchOrderPackagesResponse.Response.tuple.old.rowset.row'],
    blueprint: {
      totalCount: '$..TotalCount',
      orderPackages: [
        '$..old.rowset.row',
        {
          id: '$.ID',
          awPackageID: '$.AWPackageID',
          createdOn: '$.CreatedOn',
          orderPackageStatus: '$.OrderPackageStatus',
          statusID: '$.StatusID',
          orderPackageType: '$.FormName',
          orderPackageCode: '$.FormCode',
          assignedCRS: '$.AssignedCRS',
          assignedEPC: '$.AssignedEPC',
          popStartDate: '$.POPDate'
        }
      ]
    }
  });
  cleanUpResponse(response);
  if (!response.totalCount) {
    response.totalCount = 0;
  }
  const orderPackageResults = response.orderPackages;
  for (const orderPackage of orderPackageResults) {
    orderPackage.createdOn = formatServerDate(parseServerDateTime(orderPackage.createdOn));
  }
  return response;
}
